<script context="module">
  import UpdatePageTemplate from "$lib/pageTemplates/UpdatePageTemplate.svelte";
  import StoryPageTemplate from "$lib/pageTemplates/StoryPageTemplate.svelte";
  import CategoryPageTemplate from "$lib/pageTemplates/CategoryPageTemplate.svelte";
  import ProfilePageTemplate from "$lib/pageTemplates/ProfilePageTemplate.svelte";
  import FreeformPageTemplate from "$lib/pageTemplates/FreeformPageTemplate.svelte";
  import ResultsPageTemplate from "$lib/pageTemplates/ResultsPageTemplate.svelte";
  import SpeakerProfilePageTemplate from "../../lib/pageTemplates/SpeakerProfilePageTemplate.svelte";
  import isPreviewBuild from "$lib/utilities/isPreviewBuild";
  import Button from "$lib/components/Button.svelte";

  const PAGE_TEMPLATE_MAP = {
    updatePageTemplate: UpdatePageTemplate,
    storyPageTemplate: StoryPageTemplate,
    categoryPageTemplate: CategoryPageTemplate,
    profilePageTemplate: ProfilePageTemplate,
    freeformPageTemplate: FreeformPageTemplate,
    resultsPageTemplate: ResultsPageTemplate,
    speakerProfilePageTemplate: SpeakerProfilePageTemplate
  };
</script>

<script>
  import { setContext } from "svelte";

  import Seo from "$lib/components/SEO.svelte";
  import SocialMedia from "$lib/components/SocialMedia.svelte";
  export let data;

  const isPreview = isPreviewBuild();
  const spaceId = import.meta.env.VITE_CONTENTFUL_SPACE_ID;
  const environmentId = data.pageEntry.sys.environment.sys.id;
  const entryId = data.pageEntry.sys.id;
  const previewEntryURL = `https://app.contentful.com/spaces/${spaceId}/environments/${environmentId}/entries/${entryId}`;

  //Currently I only need to know about category pages, but making this generic
  setContext("pageType", data.pageEntry.sys.contentType.sys.id);
</script>

<Seo
  data={data.pageEntry.fields.pageData.fields}
  currentUrl={data.currentUrl}
  cookieBanner={data.cookieBanner}
/>
<SocialMedia />

<svelte:component
  this={PAGE_TEMPLATE_MAP[data.pageEntry.sys.contentType.sys.id]}
  page={data.pageEntry}
/>

{#if isPreview}
  <Button variant="primary" url={previewEntryURL} class="fixed bottom-80 left-10 hidden sm:flex"
    >Edit Page</Button
  >
{/if}
